import script from "./HeroResponsivo.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroResponsivo.vue?vue&type=script&setup=true&lang=js"

import "./HeroResponsivo.vue?vue&type=style&index=0&id=0254d3ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0254d3ff"]])

export default __exports__